(function() {
    "use strict";

    angular.module("eSign")
      .controller("GetCustomerInfoController", ['$scope', 'signTaskService', 'appConfig', '$window', function($scope, signTaskService, appConfig, $window) {

        var parseRadioButtonValues = function() {
          if($scope.customerInfo != null) {
            var c = $scope.customerInfo;
            c.isStandardBankCustomer = parseRadioValue(c.isStandardBankCustomer);
            c.isPoliticallyExposedPerson = parseRadioValue(c.isPoliticallyExposedPerson);
            c.isCitizen = parseRadioValue(c.isCitizen);
            c.isTaxableAbroad = parseRadioValue(c.isTaxableAbroad);
            $scope.customerInfo = c;
          }
        }

        var parseRadioValue = function(value) {
            return (value == "yes" ? true : false);
        }

        $scope.submitForm = function() {
          parseRadioButtonValues();
          console.log($scope.customerInfo);

          signTaskService.submitCustomerForm($scope.customerInfo).then(function(response) {
            // TODO: Possible response handling
              $window.location = appConfig.chooseDocumentUrl;
          });

          };

		  $scope.loadingJobTitles = true;

          $scope.jobtitles = null;
          var getJobTitles = function() {
			  signTaskService.getJobTitles().then(function (response) {
				  $scope.jobtitles = angular.fromJson(response.data);
				  $scope.loadingJobTitles = false;
              });
          }

		  getJobTitles();
		  
          
        }]);
}());
